/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Confirm_Manual_ModeInputs */

const vi_irrigation_pump_confirm_manual_mode = /** @type {(inputs: Irrigation_Pump_Confirm_Manual_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ gửi được khi màn điều khiển SmartLab đang ở chế độ Thủ công.`)
};

/**

* @param {Irrigation_Pump_Confirm_Manual_ModeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_manual_mode = /** @type {((inputs?: Irrigation_Pump_Confirm_Manual_ModeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_Manual_ModeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_manual_mode(inputs)
});